import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ClientLpTranslator } from '../clientLp.translator';
import { ClientLpAction } from '../clientLp.action';
import { clientLpAdapterSchemasSelector } from '../_selectors/clientLpAdapterSchemas.selector';
import { clientLpSelector } from '../_selectors/clientLp.selector';

type IState =
  & IGetSelectorStateType<typeof clientLpAdapterSchemasSelector>
  & IGetSelectorStateType<typeof clientLpSelector>;
type IDependencies = IClientApiDependencySegment;

export const updateClientLpEpic: IEpic<IState, IDependencies> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientLpAction.update.started),
  withLatestFrom(state$),
  mergeMap(([clientLp, state]) => {
    // The form shows the adapter read-only, so RHF drops it from the submitted values: read it from the store.
    const adapterName = clientLpSelector(state, { lpId: clientLp.lpId })?.adapter ?? clientLp.adapter;
    const schemas = clientLpAdapterSchemasSelector(state, { adapterName });
    const apiPayload = ClientLpTranslator.toApi(clientLp, schemas);
    return dependencies.api.updateLp(apiPayload).pipe(
      mergeMap(() => {
        return [
          ClientLpAction.update.done({ params: clientLp }),
        ];
      }),
      catchApiError((error) => {
        return [
          ClientLpAction.update.failed({ params: clientLp, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
